@if (!editMode) {
  <div class="flex content-center flex-row">
    <p data-cy="public-message" class="flex content-center">{{publicMessage?.text}}</p>
    @if (isAdminStaffMember) {
      <sup>
        <button mat-icon-button (click)="editMode = true" data-cy="public-message-edit-btn"><mat-icon>edit</mat-icon></button>
      </sup>
    }
  </div>
} @else {
  <div class="flex content-center flex-row">
    <form [formGroup]="publicMessageForm">
      <mat-form-field>
        <mat-label>Message</mat-label>
        <input matInput formControlName="publicMessage" data-cy="public-message-input">
      </mat-form-field>
      <button mat-button type="submit" (click)="save()" [disabled]="publicMessageForm.invalid" data-cy="public-message-submit">
        <mat-icon>save</mat-icon>Enregistrer
      </button>
    </form>
  </div>
}
